import { Layout } from 'antd'
import { HeaderSection } from 'app/components/Layouts'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import styled from 'styled-components'
import { useToken } from 'app/hooks'
import { useLocation } from 'react-router'
import ModernTabNavigation from '../../components/ModernTabNavigation'
import AdminPCSetting from './AdminPCSetting'
import AdminProcessSetting from './AdminProcessSetting'
import CurrencySetting from './CurrencySetting'
import ExChangeSetting from './ExChangeSetting'
import IPSetting from './IPSetting'
import PopupSetting from './PopupSetting'
import SlippageUser from './SlippageUser'

const StyledLayout = styled(Layout)`
  background: #f8f9fa;
  min-height: 100vh;
`

const StyledContent = styled(Layout.Content)`
  padding: 0 50px 20px;

  @media (max-width: 768px) {
    padding: 0 5px 20px;
  }
`
export const AdminSystemPage = () => {
	const location = useLocation()
	const { level } = useToken()

	const url = location.pathname

	const items = level == 99
		? [
				{
					title: '거래소설정',
					link: '/system/1',
				},
				{
					title: '제한프로그램',
					link: '/system/5',
				},
				{
					title: '아이피차단',
					link: '/system/2',
				},
				{
					title: '팝업설정',
					link: '/system/3',
				},
				{
					title: '환율관리',
					link: '/system/6',
				},
				{
					title: '강제슬리피지',
					link: '/system/7',
				},
				{
					title: '관리자PC',
					link: '/system/4',
				},
		  ]
		: [
				{
					title: '제한프로그램',
					link: '/system/5',
				},
				{
					title: '아이피차단',
					link: '/system/2',
				},
				{
					title: '팝업설정',
					link: '/system/3',
				},
				{
					title: '환율관리',
					link: '/system/6',
				},
		  ]

	const renderContent = () => {
		switch (url) {
			case '/system':
			case '/system/1':
				return <ExChangeSetting />
			case '/system/2':
				return <IPSetting />
			case '/system/3':
				return <PopupSetting />
			case '/system/4':
				return <AdminPCSetting />
			case '/system/5':
				return <AdminProcessSetting />
			case '/system/6':
				return <CurrencySetting />
			case '/system/7':
				return <SlippageUser />
			default:
				return <ExChangeSetting />
		}
	}

	return (
		<StyledLayout>
			<Helmet>
				<title>ADMIN - 시스템</title>
			</Helmet>
			<HeaderSection />
			<ModernTabNavigation items={items} />
			<StyledContent>
				{renderContent()}
			</StyledContent>
		</StyledLayout>
	)
}
